<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

/**
 * The one treatment for author-only information inside the preview: a muted, dashed-bordered
 * italic line.
 *
 * The preview shows a kid's view, but a few things have to be visible that no kid would see —
 * correct options, gap answers, rubrics, points. Routing them all through this component keeps the
 * boundary greppable: a line outside it claims to be something a kid would see. This is not
 * grading; it renders what the author wrote.
 */
defineOptions({
  name: 'PreviewAuthorNote',
})
</script>

<template>
  <AppText
    class="preview-author-note"
    name="body2"
    color="slate-500"
  >
    <slot />
  </AppText>
</template>

<style scoped lang="scss" src="./PreviewAuthorNote.scss" />
